import { Color } from "@skillscratch/shared-constants";

export function TreasureCount({ treasureFoundCount }: { treasureFoundCount: number }) {
    return (
      <div
        style={{
          background: Color.darkerGold,
          color: "#fff",
          padding: "2cqw 0",
          borderRadius: "1.5cqw",
  
          width: "18cqw",
  
          fontSize: "6cqw",
        }}
      >
        <div
          style={{
            width: "fit-content",
            margin: "0 auto",
            lineHeight: "1",
            paddingBottom: "0.2em",
          }}
        >
          {treasureFoundCount}
        </div>
        <div
          style={{
            fontSize: "0.5em",
            lineHeight: "1",
            textAlign: "center",
          }}
        >
          Treasures
        </div>
      </div>
    );
  }
  